/* AUTO-GENERATED FILE. DO NOT EDIT.
 * Generated by scripts/generate-build-info.mjs
 * Source: sentry-config.json
 */

export const BUILD_INFO = {
  project: "assessor-v4",
  sentryVersion: "4.0.16",
  sentryRelease: "assessor-v4@4.0.16",
  sentryDist: "20261015.100136",
  buildDateUtc: "2026-10-15T10:01:36Z",
} as const;

export type BuildInfo = typeof BUILD_INFO;
